import {actions as A} from '../constants/actions';

export const setPage = page => dispatch => {
  dispatch({
    type: A.SET_TASKS_PAGE,
    payload: {page}
  });
};
